import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { Prices } from '../components/Prices.js';

const PricesContainer = ({ className , discount , orientation , originalPrice , totalPrice  })=>{
    const { currency , locale , getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            freeProduct: getLabel('products.freeProduct')
        })
    , [
        locale,
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(Prices, {
        className: className,
        currency: currency,
        discount: discount,
        orientation: orientation,
        originalPrice: originalPrice,
        totalPrice: totalPrice,
        labels: labels
    });
};

export { PricesContainer, PricesContainer as default };
//# sourceMappingURL=PricesContainer.js.map
